// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-button {
  box-sizing: border-box;
  min-width: 40px;
  height: 36px;
  background: #ffffff;
  border: none;
  margin: 0px 6px;
  border-bottom: none;
  cursor: pointer;
  padding: 0 10px;
  white-space: nowrap;
}

.horizontal-rule {
  width: 184px;
  height: 0px;
  border: 1px solid #cccccc;
}

.arrow-up {
  color: #cc0000;
  width: 16px;
  height: 16px;
}

.table {
  background: #ffffff;
  gap: 1px;
  width: 100%;
  height: 100%;
  left: 316px;
  top: 308px;
  margin-top: 10px;
}

.effective-search-term {
  align-items: center;
  background: #f7f9fc;
  border: 1px solid #d9e3ea;
  border-radius: 999px;
  box-shadow: 0 2px 0 rgba(18, 57, 77, 0.08);
  color: #667085;
  display: flex;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  font-weight: 700;
  gap: 8px;
  justify-content: center;
  line-height: 1.2;
  margin: 0 auto 16px;
  max-width: min(100%, 720px);
  min-height: 42px;
  padding: 0 22px;
  text-align: center;
  width: -moz-fit-content;
  width: fit-content;
}

.effective-search-term strong {
  color: #12394d;
  font-size: 18px;
  font-weight: 800;
}

.back-to-search-row {
  display: flex;
  justify-content: flex-end;
  margin: 12px 0 0;
  padding-right: 126px;
}

.back-to-search-button {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c9d5dc;
  border-radius: 999px;
  box-shadow: 0 2px 0 rgba(18, 57, 77, 0.08);
  color: #12394d;
  cursor: pointer;
  display: inline-flex;
  font-family: "Roboto Bold", "Roboto", sans-serif;
  font-size: 18px;
  font-weight: 800;
  gap: 8px;
  min-height: 50px;
  padding: 0 28px;
  transition: background-color 160ms ease, border-color 160ms ease,
    box-shadow 160ms ease, color 160ms ease, transform 160ms ease;
}

@media (max-width: 850px) {
  .back-to-search-row {
    padding-right: 20px;
  }
}

.back-to-search-button:hover,
.back-to-search-button:focus-visible {
  background: #edf6f8;
  border-color: #3f7986;
  box-shadow: 0 6px 18px rgba(18, 57, 77, 0.16);
  color: #12394d;
  outline: none;
  transform: translateY(-1px);
}

.table-horizontal-rule {
  border-bottom: 1px solid #e5e5e5;
}

.title-text {
  font-size: large;
  font-weight: bold;
  font-family: "Roboto Slab";
  color: #12394d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}

.table-head {
  font-family: "Roboto";
  font-style: normal;
  color: #666666;
  border-bottom: 1px solid #e5e5e5;
  vertical-align: middle;
}

.table-th-2 {
  margin-top: 5px;
  padding-top: 18px;
  padding-bottom: 15px;
  vertical-align: middle;
  font-weight: 10;
}

.ellipsis {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.ellipsis2 {
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.filters {
  display: none;
}

.analytics-button {
  border: 2px solid #1a1a1a;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

.visited-row {
  color: purple !important;
}

.filter-button {
  border: 2px solid #cc0000;
  color: #cc0000;
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 8px;
  width: 130px;
  background-color: #e5e5e5;
}

.modal-title-style {
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
}

.filter-modal-title {
  margin: 0;
  padding: 12px;
  font-weight: 700;
  font-size: 30px;
  color: #12394d;
}

.modal-body > .left-pane-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 1024px) {
  .left-pane {
    display: none;
  }

  .filters {
    display: flex;
    justify-content: space-around;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/search-results.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gDAAgD;EAChD,eAAe;EACf,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf;iEAC+D;AACjE;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;AACF","sourcesContent":[".pagination-button {\n  box-sizing: border-box;\n  min-width: 40px;\n  height: 36px;\n  background: #ffffff;\n  border: none;\n  margin: 0px 6px;\n  border-bottom: none;\n  cursor: pointer;\n  padding: 0 10px;\n  white-space: nowrap;\n}\n\n.horizontal-rule {\n  width: 184px;\n  height: 0px;\n  border: 1px solid #cccccc;\n}\n\n.arrow-up {\n  color: #cc0000;\n  width: 16px;\n  height: 16px;\n}\n\n.table {\n  background: #ffffff;\n  gap: 1px;\n  width: 100%;\n  height: 100%;\n  left: 316px;\n  top: 308px;\n  margin-top: 10px;\n}\n\n.effective-search-term {\n  align-items: center;\n  background: #f7f9fc;\n  border: 1px solid #d9e3ea;\n  border-radius: 999px;\n  box-shadow: 0 2px 0 rgba(18, 57, 77, 0.08);\n  color: #667085;\n  display: flex;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  gap: 8px;\n  justify-content: center;\n  line-height: 1.2;\n  margin: 0 auto 16px;\n  max-width: min(100%, 720px);\n  min-height: 42px;\n  padding: 0 22px;\n  text-align: center;\n  width: fit-content;\n}\n\n.effective-search-term strong {\n  color: #12394d;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.back-to-search-row {\n  display: flex;\n  justify-content: flex-end;\n  margin: 12px 0 0;\n  padding-right: 126px;\n}\n\n.back-to-search-button {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #c9d5dc;\n  border-radius: 999px;\n  box-shadow: 0 2px 0 rgba(18, 57, 77, 0.08);\n  color: #12394d;\n  cursor: pointer;\n  display: inline-flex;\n  font-family: \"Roboto Bold\", \"Roboto\", sans-serif;\n  font-size: 18px;\n  font-weight: 800;\n  gap: 8px;\n  min-height: 50px;\n  padding: 0 28px;\n  transition: background-color 160ms ease, border-color 160ms ease,\n    box-shadow 160ms ease, color 160ms ease, transform 160ms ease;\n}\n\n@media (max-width: 850px) {\n  .back-to-search-row {\n    padding-right: 20px;\n  }\n}\n\n.back-to-search-button:hover,\n.back-to-search-button:focus-visible {\n  background: #edf6f8;\n  border-color: #3f7986;\n  box-shadow: 0 6px 18px rgba(18, 57, 77, 0.16);\n  color: #12394d;\n  outline: none;\n  transform: translateY(-1px);\n}\n\n.table-horizontal-rule {\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.title-text {\n  font-size: large;\n  font-weight: bold;\n  font-family: \"Roboto Slab\";\n  color: #12394d;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.table-head {\n  font-family: \"Roboto\";\n  font-style: normal;\n  color: #666666;\n  border-bottom: 1px solid #e5e5e5;\n  vertical-align: middle;\n}\n\n.table-th-2 {\n  margin-top: 5px;\n  padding-top: 18px;\n  padding-bottom: 15px;\n  vertical-align: middle;\n  font-weight: 10;\n}\n\n.ellipsis {\n  max-width: 150px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.ellipsis2 {\n  max-width: 250px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.filters {\n  display: none;\n}\n\n.analytics-button {\n  border: 2px solid #1a1a1a;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n.visited-row {\n  color: purple !important;\n}\n\n.filter-button {\n  border: 2px solid #cc0000;\n  color: #cc0000;\n  display: flex;\n  padding: 6px 16px;\n  align-items: center;\n  gap: 8px;\n  width: 130px;\n  background-color: #e5e5e5;\n}\n\n.modal-title-style {\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n}\n\n.filter-modal-title {\n  margin: 0;\n  padding: 12px;\n  font-weight: 700;\n  font-size: 30px;\n  color: #12394d;\n}\n\n.modal-body > .left-pane-modal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (max-width: 1024px) {\n  .left-pane {\n    display: none;\n  }\n\n  .filters {\n    display: flex;\n    justify-content: space-around;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
